<template>
  <div>
      <div class="simple-container" id="Jmain" style="min-height: 896px;">
    <div class="simple-header">
      <img src="../assets/images/NewHelpCenter.png">
      <div class="simple-header-content">
        <p>湖北省数字版权综合服务平台帮助中心</p>
        <div class="search">
          <form>
              <!-- vmData.searchNotice: 搜索内容-->
            <input class="search-input" type="text" name="keyWord" placeholder="搜索内容">
            <button class="search-btn Jsearch anticon anticon-search">
              <img src="../assets/images/c_icon_search.png" alt="">
            </button>
          </form>
        </div>
      </div>
    </div>
    <div class="simple-content container">
      <div class="simple-item">
          <!-- vmData.hotQuestion: 热门问题：-->
        <div class="simple-item-title">热门问题</div>
        <ul>

                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">湖北省数字版权综合服务平台产品下线公告</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">湖北省数字版权综合服务平台详细使用指南</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">湖北省数字版权综合服务平台专业版产品介绍</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">新用户使用手册</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">版权保护资费标准</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">湖北省互联网法院诉讼平台证据核验流程</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">如何给店铺子账号分配湖北省数字版权综合服务平台的操作权限</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">无法进行企业四要素认证？</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">《湖北省数字版权综合服务平台取证标准说明》</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">如何注册湖北省数字版权综合服务平台？</a>
                      </li>
          
        </ul>
      </div>
      <div class="simple-item">
        <div class="simple-item-title">最新问题</div>
        <ul>

                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">湖北省数字版权综合服务平台产品下线相关问题</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">《湖北省数字版权综合服务平台取证标准说明》</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">湖北省数字版权综合服务平台产品下线公告</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">2022年6月30日湖北省数字版权综合服务平台迁移下线</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">湖北省数字版权综合服务平台专业版产品介绍</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">文字版权授权交易相关问题</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">湖北省数字版权综合服务平台常见问题FAQ</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">湖北省数字版权综合服务平台数字证据的提取和使用（持续更新）</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">如何添加企业子账号？</a>
                      </li>
                    <li>
            <span class="anticon anticon-dot"></span>
                            <a href="javascript:;">如何查看监测返回数据？</a>
                      </li>
          
        </ul>
      </div>


    </div>

  </div>
  </div>
</template>

<script>
export default {
  name: "NewHelpCenter",
  data() {
    return {};
  },

  methods: {},
};
</script>

<style scoped>
.simple-container, .default-container, .tree-container, .search-page, .detail-page {
    background: #fff;
    -webkit-border-radius: 5px;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 5px;
    -moz-background-clip: padding;
    border-radius: 5px;
    background-clip: padding-box;
}
.simple-container .simple-header {
    text-align: center;
    height: 260px;
    overflow: hidden;
    position: relative;
}
.simple-container .simple-header img {
    width: 100%;
    height: 100%;
}
.simple-container .simple-header .simple-header-content {
    position: absolute;
    width: 600px;
    top: 0;
    left: 50%;
    margin-left: -300px;
}
.simple-container .simple-header p {
    padding: 97px 0 40px 0;
    color: #fff;
    font-size: 24px;
    letter-spacing: 2px;
}
.simple-container .simple-header .search {
    width: 600px;
    height: 40px;
    line-height: 40px;
    position: relative;
    margin: 0 auto;
}
.search-input {
    padding-left: 17px;
    -webkit-border-top-left-radius: 6px;
    -moz-border-radius-topleft: 6px;
    border-top-left-radius: 6px;
    -webkit-border-bottom-left-radius: 6px;
    -webkit-background-clip: padding-box;
    -moz-border-radius-bottomleft: 6px;
    -moz-background-clip: padding;
    border-bottom-left-radius: 6px;
    background-clip: padding-box;
    -webkit-transition: border 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-box-shadow 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    -moz-transition: border 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), -moz-box-shadow 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    -o-transition: border 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), box-shadow 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), box-shadow 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.simple-container .simple-header .search .search-input {
    height: 40px;
    width: 591px;
    line-height: 40px;
    position: absolute;
    left: 0;
    border: 1px solid #fff;
    -webkit-border-radius: 6px;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 6px;
    -moz-background-clip: padding;
    border-radius: 6px;
    background-clip: padding-box;
    outline: none;
    border: none;
}
.anticon {
    display: inline-block;
    font-style: normal;
    vertical-align: baseline;
    text-align: center;
    text-transform: none;
    text-rendering: auto;
    line-height: 1;
}
.simple-content, .default-content, .search-content {
    background: #fff;
    padding: 64px 0 56px;
}
.simple-container .simple-content {
    overflow: hidden;
    -webkit-border-bottom-right-radius: 5px;
    -moz-border-radius-bottomright: 5px;
    border-bottom-right-radius: 5px;
    -webkit-border-bottom-left-radius: 5px;
    -webkit-background-clip: padding-box;
    -moz-border-radius-bottomleft: 5px;
    -moz-background-clip: padding;
    border-bottom-left-radius: 5px;
    background-clip: padding-box;
}
.simple-container .simple-content .simple-item {
    padding: 0 5%;
    float: left;
    width: 50%;
}
.simple-container .simple-content .simple-item .simple-item-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    padding-bottom: 20px;
}
.simple-container .simple-content .simple-item ul {
    line-height: 30px;
}
.simple-container .simple-content .simple-item ul li {
    width: 100%;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.anticon {
    display: inline-block;
    font-style: normal;
    vertical-align: baseline;
    text-align: center;
    text-transform: none;
    text-rendering: auto;
    line-height: 1;
    position: relative;
    width: 4px;
    height: 4px;
    background: #666;
    border-radius: 50%;
    margin-right: 10px;
    vertical-align: middle;
}
.simple-container .simple-header .search .search-btn {
    display: inline-block;
    height: 38px;
    line-height: 40px;
    width: 72px;
    position: absolute;
    top: 1px;
    right: 10px;
    border-style: none;
    background: #fff;
    -webkit-border-top-right-radius: 6px;
    -moz-border-radius-topright: 6px;
    border-top-right-radius: 6px;
    -webkit-border-bottom-right-radius: 6px;
    -webkit-background-clip: padding-box;
    -moz-border-radius-bottomright: 6px;
    -moz-background-clip: padding;
    border-bottom-right-radius: 6px;
    background-clip: padding-box;
    color: #666;
    font-size: 20px;
}
.simple-container .simple-header .search .search-btn img{
  width: 20px;
  height: 20px;
  margin-top: -5px;
  margin-right: -15px;
}
a {
    text-decoration: none;
    color: #666;
}


@media screen and (max-width: 991px) {
  .search{display: none;}
}

</style>